// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","button":"card-button_button__5Og79","investmentOpportunities":"card-button_investmentOpportunities__g22lQ"};